import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const SortableItem = ({
  id,
  disabled,
  container: Container = 'div',
  children,
}) => {
  const {
    active,
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled })
  const transformValue = CSS.Transform.toString(transform)
  const style = {
    transform: `${transformValue || ''}${
      isDragging ? ' scale(1.02)' : ''
    }`.trim(),
    transition: isDragging ? 'none' : transition || 'transform 250ms ease',
    willChange: 'transform',
    opacity: isDragging ? 0.85 : 1,
    boxShadow: isDragging ? '0 8px 20px rgba(0, 0, 0, 0.25)' : undefined,
    position: isDragging || active?.id === id ? 'relative' : undefined,
    zIndex: isDragging || active?.id === id ? 1 : undefined,
    alignSelf: Container === 'div' ? 'start' : undefined,
    borderRadius: Container === 'div' ? '16px' : undefined,
  }

  return (
    <Container ref={setNodeRef} style={style}>
      {children({ attributes, disabled, listeners, setActivatorNodeRef })}
    </Container>
  )
}

export default SortableItem
